import React, { useEffect, useRef, useState } from 'react'
import IconComponent from '../icons';
import { pureKeys } from "../../utils/helpers"

const SearchBox = (props)=> {
  const {data, noResults, searchHeading, searchPlaceholder, handleResultsOnSearch, userInput, setUserInput, productText, expertiseText, handleSearchClose} = props;
  const inputRef = useRef(null);
  const searchBoxRef = useRef(null)
  const [suggestionsCategories, setSuggestionsCategories] = useState([]);
  const [showSuggestions, setshowSuggestions] = useState(false);
  const [suggestionsProducts, setSuggestionsProducts] = useState([]);

  const isAllow = (val) => {
    return (val.length >= 3 && val !== '') ? true : false;
  }

  useEffect(()=>{
    document.addEventListener('click', handleOutsideClick);
    if(sessionStorage.getItem("searchedCategories") !== null){
      setUserInput(sessionStorage.getItem("searchedCategories"));
    }
  }, [setUserInput])

  const getProductNameByCategory =(val)=>{
    const matchedProducts = [];
    data.forEach((x)=>{
      x.productCategory.some((z)=>{
        if(z.title.toLowerCase().indexOf(val.toLowerCase()) !== -1){
          return matchedProducts.push(x.title); 
        }
        else{
          return false;
        }
      })
    })
    return matchedProducts;
  }

  const getProductNameByValue =(val)=>{
    const matchedProducts = [];
    data.forEach((x)=>{
      if(x.title.toLowerCase().indexOf(val.toLowerCase()) !== -1){
        return matchedProducts.push(x.title);
      }
    })
    return matchedProducts;
  }

  const allCategories = [];
  data && data.length && data.map((product)=>{
     return allCategories.push(...product.productCategory);
  })

  const onChange =(e)=>{
    let inputVal = e.currentTarget.value;
    inputVal = (inputVal.trim() !== '') ? e.currentTarget.value : '';

    let filterProductsObj = [];
    let filterCategoriesObj = [];
    if(isAllow(inputVal)){     
      
      filterProductsObj = data && data.length && data.filter((item)=>{
        return item.title.toLowerCase().indexOf(inputVal.toLowerCase()) !== -1;
      }); 

      filterCategoriesObj = allCategories && allCategories.length && allCategories.filter((item)=>{
        return item.title.toLowerCase().indexOf(inputVal.toLowerCase()) !== -1;
      });

      setshowSuggestions(true);
    }

    setSuggestionsProducts(filterProductsObj);
    setSuggestionsCategories(filterCategoriesObj);
    setUserInput(inputVal);
  }
  const onKeyDown =(e)=>{
    const inputVal = e.currentTarget.value;
    if (isAllow(inputVal) && e.keyCode === 13) {
      const isProductMatch = getProductNameByValue(inputVal);
      if(isProductMatch.length){
        handleResultsOnSearch(getProductNameByValue(inputVal), inputVal); 
      }
      else{
        handleResultsOnSearch(getProductNameByCategory(inputVal), inputVal); 
      }
      setUserInput(inputVal);
      setshowSuggestions(false);
    }
  }

  const renderSuggestionsList =()=>{
    if(suggestionsProducts.length || suggestionsCategories.length){
      return(
        <ul className="max-h-[256px] lg:max-h-[317px] overflow-y-auto list-none">
        {suggestionsProducts.length ? <li className="px-5 py-[5px] text-xs font-light text-ek-grey-500 ">{productText}</li> : false}
        {suggestionsProducts.length ? suggestionsProducts.map((item)=>{
            const inputVal = inputRef?.current?.value;
            let userInputExp = inputVal.replace(/[()]/g, '');
            return <li key={pureKeys(item.title)} onClick={()=>{handleResultsOnSearch(getProductNameByValue(item.title), item.title); setUserInput(item.title); setshowSuggestions(false);}} className={`px-5 py-[5px] hover:bg-ek-grey-100 hover:text-black cursor-pointer ${suggestionsProducts.length && suggestionsCategories.length ? "mb-2.5":""}`} dangerouslySetInnerHTML={{
              __html: item.title.replace(new RegExp(userInputExp, 'ig'),
                '<span class="font-bold text-black">' + 
                item.title.match(new RegExp(userInputExp, 'i')) +
                '</span>') 
            }}
            ></li>
        }) : false}
        {suggestionsCategories.length ? <li className="px-5 py-[5px] text-xs font-light text-ek-grey-500">{expertiseText}</li> : false}
        {suggestionsCategories.length ? suggestionsCategories.map((item)=>{
            const inputVal = inputRef?.current?.value;
            let userInputExp = inputVal.replace(/[()]/g, '');
            return <li key={pureKeys(item.title)} onClick={()=>{handleResultsOnSearch(getProductNameByCategory(item.title), item.title); setUserInput(item.title); setshowSuggestions(false);}} className="px-5 py-[5px] hover:bg-ek-grey-100 hover:text-black cursor-pointer" dangerouslySetInnerHTML={{
              __html: item.title.replace(new RegExp(userInputExp, 'ig'),
                '<span class="font-bold text-black">' + 
                item.title.match(new RegExp(userInputExp, 'i')) +
                '</span>') 
            }}
            ></li>
        }) : false}
        </ul>
      )
    }
    else{
      return(
        <ul className='list-none'>
          <li className="px-5 py-2 mb-1 text-black font-bold">{noResults}</li>
        </ul>
      )
    }
  }

  const handleOutsideClick = (event) => {
    if (searchBoxRef && searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
      setshowSuggestions(false);
    }
  }


  const renderSearchBox =()=>{
    return (
      <div ref={searchBoxRef}>
        {searchHeading && <div className="text-lg font-bold text-black mb-4 leading-[27px] tracking-[.36px]">{searchHeading}</div>}
        <div className="relative w-full flex items-center lg:max-w-[614px]">
          <span className="absolute left-4"><IconComponent icon="search-outlined" className="text-ek-red" /></span>
          <input ref={inputRef} value={userInput} onChange={(e)=>{onChange(e)}}
           onKeyDown = {(e)=>{onKeyDown(e)}}
          type="text" name="network-input" 
          autoComplete="off"
          placeholder={searchPlaceholder} className="border border-ek-grey-300 px-5 py-5 lg:py-[13px] pl-11 lg:pl-12 pr-12 rounded-lg focus:outline-none appearance-none tracking-[0.64px] w-full h-[47px] lg:h-[50px] text-ek-grey-500 placeholder:text-ek-grey-500 placeholder:lg:text-ek-grey-400 " />
          {userInput !== '' && <span  onClick={()=>{setUserInput(""); setshowSuggestions(false);handleSearchClose();}}className="absolute right-0 h-full items-center flex px-4 cursor-pointer"><IconComponent icon="close" className="text-ek-grey-400" /></span>}
          {<div className={`${showSuggestions && userInput.length ? "" : "hidden"} w-full py-[15px] bg-white rounded-lg border border-ek-grey-300 absolute top-[46px] lg:top-[49px] left-0 z-10 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.07)] text-sm font-normal text-ek-grey-500 leading-[21px] tracking-[0.56px]`}>{renderSuggestionsList()}</div>}
        </div>
      </div>
    )
  }
  
  return (
    <>
      {renderSearchBox()}
    </>
  )
}

export default SearchBox;
